import { Group, useMantineTheme } from "@mantine/core"
import { IconCertificate, IconHeartHandshake } from "@tabler/icons-react"
import { ColumnDef, createColumnHelper } from "@tanstack/react-table"
import { Missing } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { RiskScoreDisplay } from "~/pages/Brand/Suppliers/List/components/RiskScore.tsx"

const columnHelper = createColumnHelper<LibraryResponses.SupplierRisks>()

export const useColumns = () => {
  const { t } = useTranslation("suppliers")
  const { colors } = useMantineTheme()

  return useMemo<ColumnDef<LibraryResponses.SupplierRisks, any>[]>(
    () => [
      columnHelper.accessor("company_name", {
        id: "company_name",
        header: t("risk.table.companyName"),
        cell: (info) => info.getValue(),
      }),

      columnHelper.accessor("collaboration_risk", {
        id: "collaboration_risk",
        header: t("risk.table.collaborationRisk"),
        cell: (info) => {
          const risk = info.getValue()
          return risk !== undefined ? (
            <Group gap="xs">
              <IconHeartHandshake color={colors.beige[9]} size={16} />
              <RiskScoreDisplay risk={risk} />
            </Group>
          ) : (
            <Missing />
          )
        },
      }),
      columnHelper.accessor("certificate_risk", {
        id: "certificate_risk",
        header: t("risk.table.certificationRisk"),
        cell: (info) => {
          const risk = info.getValue()
          return risk !== undefined ? (
            <Group>
              <IconCertificate color={colors.beige[9]} size={16} />
              <RiskScoreDisplay risk={risk} />
            </Group>
          ) : (
            <Missing />
          )
        },
      }),
    ],
    [t, colors.beige]
  )
}
